import { ScoreTagLevel } from "features/common/ScoreTag";

/**
 * Converts boolean disabled state to proper Gux component format
 * @param disabled - The disabled state
 * @returns true if disabled, undefined if enabled (for accessibility)
 */
export const toGuxDisabled = (disabled: boolean | undefined | null) => {
    return disabled ? true : undefined;
};

type ScoreValueLabelFn = (data: { value: number | string }) => string;

export function getScoreValueAriaLabel(
    labels: {
        scoreValue: ScoreValueLabelFn;
        criticalScoreValue: ScoreValueLabelFn;
        fatalScoreValue: ScoreValueLabelFn;
    },
    questionLevel: ScoreTagLevel,
    value: number | string
): string {
    const labelFn =
        questionLevel === "fatal"
            ? labels.fatalScoreValue
            : questionLevel === "critical"
            ? labels.criticalScoreValue
            : labels.scoreValue;
    return labelFn({ value: value ?? 0 });
}
